module.exports = __webpack_public_path__ + "img/ico-2-active.25a3c741.svg";